import { render, staticRenderFns } from "./dialog-activity-info.vue?vue&type=template&id=30a08820&scoped=true"
import script from "./dialog-activity-info.vue?vue&type=script&lang=js"
export * from "./dialog-activity-info.vue?vue&type=script&lang=js"
import style0 from "./dialog-activity-info.vue?vue&type=style&index=0&id=30a08820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a08820",
  null
  
)

export default component.exports